import { Link } from "react-router-dom";

interface BrandLogoProps {
  onNavigate?: () => void;
}

export default function BrandLogo({ onNavigate }: BrandLogoProps) {
  return (
    <Link
      to="/"
      onClick={onNavigate}
      className="flex items-center gap-2 cursor-pointer"
      aria-label="小蜜桃首页"
    >
      <span className="w-9 h-9 rounded-full bg-primary-500 text-background-50 flex items-center justify-center text-lg">
        <i className="ri-plant-line"></i>
      </span>
      <span className="flex flex-col leading-none">
        <span className="font-brand text-2xl text-primary-600 tracking-wide">小蜜桃</span>
        <span className="text-[10px] tracking-[0.3em] text-foreground-500 mt-0.5">
          PEACH MEDIA
        </span>
      </span>
    </Link>
  );
}